<template>
    <div class="c-input-files">
        <b-row class="mb-3">
            <b-col :key="'file_' + fileIndex" v-for="file, fileIndex in dataValue">
                <img v-if="Core.File.isImage(file.type)" width="100%" :src="file.src" />
                <div v-else>
                    <i v-if="Core.File.isPDF(file.type)" class="fa fa-file-pdf-o"></i>
                    <i v-if="Core.File.isCSV(file.type)" class="fa fa-file-excel-o"></i>
                    <i v-else class="fa fa-file-o"></i>
                </div>
                <hr/>
                <b-row>
                    <b-col lg="8" sm="12">
                        {{file.name}} ({{Core.File.ocToKo(file.size)}}K)
                    </b-col>
                    <b-col class="text-right" lg="4" sm="12">
                        <b-button class="btn btn-danger" @click="trash(fileIndex)"><i class="fa fa-trash-o"></i></b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <label>{{label}}</label>
                <Alert class="mb-3" :alert="dataAlert"></Alert>
                <vue2Dropzone v-if="dataOptions!==null" :ref="id"
                              :id="id"
                              v-on:vdropzone-sending="sending"
                              v-on:vdropzone-success="success"
                              :options="dataOptions">
                </vue2Dropzone>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Alert from './Alert'
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    export default {
        name: 'InputFiles',
        components: {
            vue2Dropzone,
            Alert
        },
        props: {
            value: {
                type: Array,
                default: function() {
                    return []
                }
            },
            multiple: {
                type: Boolean,
                default: true
            },
            allowedTypes: {
                type: Array,
                default: function() { return [] }
            },
            id: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            uploadUrl: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function() {return {}}
            },
            fieldRefs: {
                type: Array,
                default: function() { return [] }
            },
            thumbnailWidth: {
                type: Number,
                default: 150
            },
            maxFilesize: {
                type: Number,
                default: 4
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.dataValue = this.value
            this.dataOptions = {
                    dictDefaultMessage: this.placeholder,
                    url: Mantle.Config.api.url + '/file',
                    thumbnailWidth: this.thumbnailWidth,
                    maxFilesize: this.maxFilesize,
                    headers: Core.Request.getHeaders(Mantle.Config.api.auth.token, Mantle.Config.api.auth.signature, Core.Session.AuthUser.email, Core.Session.AuthUser.signature, Core.Session.subDomain, Core.Session.environmentId, Core.Session.branchId, Core.Session.Setting.getSetting('lang'))
            }
        },
        data: () => {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataValue: [],
                dataAlert: {},
                dataOptions: null
            }
        },
        methods: {
            sending (file, xhr, formData) {
                formData.append('allowedTypes', Core.Value.encode(this.allowedTypes, Core.Value.typeJSON));
            },
            success(file,response) {
                if (response.alert !== undefined) {
                    this.$refs[this.id].removeFile(file)
                    this.dataAlert = response.alert
                } else {
                    if (response.file !== undefined) {
                        this.$refs[this.id].removeFile(file)
                        if (!this.multiple) {
                            this.dataValue = []
                        }
                        this.dataValue.push(response.file)
                    }
                }
            },
            trash(fileIndex) {
                this.dataValue.splice(fileIndex, 1)
            }
        }
    }
</script>